import { loadIconSet } from './iconSets/loader';

import {
  IconPack,
  IconResolver,
  ResolvedIcon,
} from './types';

interface LoadedPack {
  id: IconPack;
  icons: Record<string, ResolvedIcon>;
  resolve: IconResolver;
}

const packs = new Map<IconPack, LoadedPack>();

let activePackId: IconPack | null = null;

export const IconRegistry = {
  async loadPack(packId: IconPack): Promise<void> {
    if (packs.has(packId)) {
      return;
    }

    const mod = await loadIconSet(packId);

    packs.set(packId, {
      id: packId,
      icons: mod.icons,
      resolve: mod.resolve,
    });
  },

  async initialize(packId: IconPack): Promise<void> {
    await this.loadPack(packId);

    activePackId = packId;
  },

  initializeDefault(){
    this.initialize(IconPack['default'])
  },

  setActivePack(packId: IconPack) {
    activePackId = packId;
  },

  getActivePack() {
    return activePackId;
  },

  resolve(name: string): ResolvedIcon | undefined {
    if (!activePackId) {
      if (import.meta.env.DEV) {
        console.warn(
          '[IconRegistry] active pack not initialized'
        );
      }

      return
    }

    const activePack = packs.get(activePackId);

    return activePack?.resolve(name)
  },

  clear() {
    packs.clear();
    activePackId = null;
  },
};